export default __webpack_public_path__ + "932172a4069edfe71adb7d64fee5ed40.svg";